import React from 'react'
import PropTypes from 'prop-types'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import Checkbox from '../Checkbox'
import ChipSelectRender from './ChipSelectRender'

function ChipSelect({
  chipClassName,
  chipsClassName,
  items,
  onChange,
  onClose,
  value,
}) {
  return (
    <Select
      multiple
      value={value}
      onChange={onChange}
      onClose={onClose}
      variant="outlined"
      style={{ width: '100%' }}
      renderValue={(selectedValue) => (
        <ChipSelectRender
          selectedValue={selectedValue}
          chipsClassName={chipsClassName}
          chipClassName={chipClassName}
          items={items}
        />
      )}
    >
      {items.filter((p) => p.id !== '').map((p) => (
        <MenuItem key={p.id} value={p.id}>
          <Checkbox value={value.indexOf(p.id) > -1} />
          <ListItemText primary={p.name} />
        </MenuItem>
      ))}
    </Select>
  )
}

ChipSelect.defaultProps = {
  chipClassName: '',
  chipsClassName: '',
}

ChipSelect.propTypes = {
  chipClassName: PropTypes.string,
  chipsClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  ).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  ).isRequired,
}

export default ChipSelect
